"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var _0_3_1 = require("../../types/Mobiledoc/0.3");
var utils_1 = require("../../utils");
var TARGET_VERSION = '0.3.1';
var expandSections = function (mobiledoc) { return (__assign({ markups: mobiledoc.sections[0] }, mobiledoc.sections[1].reduce(function (_a, section) {
    var cards = _a.cards, sections = _a.sections;
    return section[0] === _0_3_1.SectionTypeIdentifier.CARD
        ? {
            cards: __spreadArrays(cards, [[section[1], section[2]]]),
            sections: __spreadArrays(sections, [
                [_0_3_1.SectionTypeIdentifier.CARD, cards.length]
            ])
        }
        : { cards: cards, sections: __spreadArrays(sections, [section]) };
}, { cards: [], sections: [] }))); };
/* Upgrade markers by adding `typeIdentifier` */
var upgradeMarker = function (marker) {
    return [_0_3_1.MarkerTypeIdentifier.TEXT].concat(marker);
};
/* Upgrade markup sections (`pull-quote` -> `aside`, upgrade markers) */
var upgradeMarkupSection = function (_a) {
    var typeIdentifier = _a[0], tagName = _a[1], markers = _a[2];
    return [
        typeIdentifier,
        (tagName === 'pull-quote' ? 'aside' : tagName),
        markers.map(upgradeMarker)
    ];
};
/* Upgrade list sections (upgrade markers) */
var upgradeListSection = function (_a) {
    var typeIdentifier = _a[0], tagName = _a[1], items = _a[2];
    return [
        typeIdentifier,
        tagName,
        items.map(function (markers) { return markers.map(upgradeMarker); })
    ];
};
var upgradeSection = function (section) {
    var _a;
    return ((_a = {},
        _a[_0_3_1.SectionTypeIdentifier.MARKUP] = upgradeMarkupSection,
        _a[_0_3_1.SectionTypeIdentifier.LIST] = upgradeListSection,
        _a[_0_3_1.SectionTypeIdentifier.IMAGE] = function (imageSection) { return imageSection; },
        _a[_0_3_1.SectionTypeIdentifier.CARD] = function (cardSection) { return cardSection; },
        _a)[section[0]](section));
};
var upgradeSections = function (mobiledoc) { return (__assign(__assign({}, mobiledoc), { sections: mobiledoc.sections.map(upgradeSection) })); };
/* Add atoms */
var addAtoms = function (mobiledoc) { return (__assign(__assign({}, mobiledoc), { atoms: [] })); };
/* Update the version */
var setVersion = function (targetVersion) { return function (mobiledoc) { return (__assign(__assign({}, mobiledoc), { version: targetVersion })); }; };
var updateVersion = setVersion(TARGET_VERSION);
/* Upgrade Mobiledoc 0.2.x to 0.3.x */
exports.default = (function (mobiledoc) {
    return utils_1.pipe([expandSections, upgradeSections, addAtoms, updateVersion])(mobiledoc);
});
